import * as AllIcons from '@mui/icons-material';
import { SvgIconProps } from '@mui/material';

const icons: { [K: string]: React.FC<SvgIconProps> } = {
  wallet: AllIcons.AccountBalanceWalletOutlined,
  taxi: AllIcons.LocalTaxiOutlined,
  subway: AllIcons.SubwayOutlined,
  bus: AllIcons.DirectionsBusOutlined,
  train: AllIcons.TrainOutlined,
  flight: AllIcons.FlightOutlined,
  bikeScooter: AllIcons.BikeScooterOutlined,
  food: AllIcons.RestaurantOutlined,
  coffee: AllIcons.LocalCafeOutlined,
  fastfood: AllIcons.FastfoodOutlined,
  icecream: AllIcons.IcecreamOutlined,
  kebab: AllIcons.KebabDiningOutlined,
  takeout: AllIcons.TakeoutDiningOutlined,
  pizza: AllIcons.LocalPizzaOutlined,
  subscriptions: AllIcons.SubscriptionsOutlined,
  grocery: AllIcons.LocalGroceryStoreOutlined,
  liquor: AllIcons.LiquorOutlined,
  bar: AllIcons.LocalBarOutlined,
  smoking: AllIcons.SmokingRoomsOutlined,
  grass: AllIcons.GrassOutlined,
  home: AllIcons.HomeOutlined,
  car: AllIcons.DirectionsCarOutlined,
  fuelGas: AllIcons.LocalGasStationOutlined,
  fuelEv: AllIcons.EvStationOutlined,
  parking: AllIcons.LocalParkingOutlined,
  carWash: AllIcons.LocalCarWashOutlined,
  bill: AllIcons.RequestQuoteOutlined,
  pharmacy: AllIcons.LocalPharmacyOutlined,
  entertainment: AllIcons.AttractionsOutlined,
  movie: AllIcons.MovieOutlined,
  service: AllIcons.ManageAccountsOutlined,
  gift: AllIcons.CardGiftcardOutlined,
  server: AllIcons.StorageOutlined,
  accessibility: AllIcons.AccessibilityNewOutlined,
  cut: AllIcons.ContentCutOutlined,
  computer: AllIcons.ComputerOutlined,
  clothes: AllIcons.CheckroomOutlined,
  homeUtility: AllIcons.RoomPreferencesOutlined,
  education: AllIcons.SchoolOutlined,
  vinyl: AllIcons.AlbumOutlined,
  heart: AllIcons.FavoriteBorderOutlined
};

export default icons;
